export const LOGOUT_MESSAGE_TIME = 2000;
export const EMAIL_HREF = 'mailto:acuvue@jnj.ru';
export const PHONE_SUPPORT_HREF = 'tel:88006007997';
export const PHONE_SUPPORT_PARENTHESES = '8 (800) 600-79-97';
export const APP_STORE_LINK_TEST_ID = 'appStore-link';
export const GOOGLE_PLAY_LINK_TEST_ID = 'googlePlay-link';
export const RU_STORE_LINK_TEST_ID = 'ruStore-link';
